var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTickMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "white",
    stroke: "#714FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67984 9.16551L4.95074 7.51114L4 8.4208L6.28178 10.604L6.2844 10.6014L6.70096 11L12 5.92734L11.0308 5L6.67984 9.16551Z",
    fill: "#7DCC18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTickMark);
export default __webpack_public_path__ + "static/media/newTickMark.2a28d98d90a39c467c8f7d568e800a5b.svg";
export { ForwardRef as ReactComponent };